import { useEffect, useState } from 'react'

import SSR_API from '@api/home/ssrAction'
import { useSearch } from '@hooks/index'
import { isMobileProject } from '@utils/index'
import { request } from '@utils/request'

export const getArticleParams = (href) => {
  const searchData = href?.split('?')?.[1] || ''
  const searchParams = new URLSearchParams(searchData)
  const urlParams = Object.fromEntries(searchParams.entries())
  let newObj: any = {}
  if (urlParams.tid) {
    newObj.articleId = ''
    newObj.template = urlParams.tid
  } else if (urlParams.aid) {
    newObj.articleId = urlParams.aid
    newObj.template = ''
  }
  return newObj
}

const defaultData = {
  articleDescription: '',
  articleName: '',
  articleId: '',
  mImage: '',
  pcImage: '',
  metaTitle: '',
  metaKeywords: '',
  metaDescription: '',
  template: '',
  origin: ''
}

export const useArticleDetail = (
  props?: ServerFC<any> & { isHandleRequest? }
) => {
  const { pageData, isHandleRequest } = props

  const [data, useData] = useState(pageData)

  useEffect(() => {
    if (!isHandleRequest) return

    SSR_API.articleDetail
      .action(request, isHandleRequest.pathname, isHandleRequest as any)
      .then((res) => {
        useData(res)
        setTimeout(() => {
          // 获取弹窗元素
          var [popup] =
            document.getElementsByClassName('__article_point__window__') || []

          const [classTargetElement] =
            document.getElementsByClassName('article_point') || []

          // 获取目标元素
          var targetElement = (document.getElementById('article_point') ||
            classTargetElement) as HTMLElement
          if (!targetElement) return
          // 计算目标元素相对于弹窗顶部的偏移量
          var offsetTop = targetElement.offsetTop

          var ratio = window.innerWidth / 750

          isMobileProject && (offsetTop = offsetTop - 80 * ratio)
          // 设置弹窗的滚动位置
          popup.scrollTop = offsetTop

          console.log('offsetTop', offsetTop)
        }, 50)

        return res
      })
  }, [JSON.stringify(isHandleRequest)])

  useEffect(() => {
    useData(pageData)
  }, [JSON.stringify(pageData)])

  const ssrData =
    {
      ...defaultData,
      ...data,
      // 包含错误信息
      articleDescription: data?.articleDescription || data?.errorMessage
    } || defaultData

  return {
    data: ssrData,
    metaData: {
      metaTitle: ssrData.metaTitle,
      metaKeywords: ssrData.metaKeywords,
      metaDescription: ssrData.metaDescription
    }
  }
}
